import { axiosInstance } from "@services/axios";

import { handleError } from "@stadium/helpers/src/error-handler";
import { formatOrder } from "@stadium/checkout/src/helpers/order";

import { showErrorToast } from "@stadium/services/react-toastify";

import { camelizer, jsonDataFormatter } from "@stadium/helpers/src/formatter";

import {
  CANCEL_ORDER_ERROR_TOAST_ID,
  RLP_USER_INFO_ERROR_TOAST_ID,
  UPDATE_ORDER_ERROR_TOAST_ID,
} from "@constants/toast-ids";
import { SM_PROGRAM_ID } from "@constants/app-defaults";
import { withSkipContacts } from "@stadium/helpers/form/utils";

const { get, patch } = axiosInstance;

export const updateTreatDetails = (number, payload) => async (dispatch) =>
  patch(`/orders/${number}/update_treat_detail`, withSkipContacts(payload))
    .then((res) => {
      return res;
    })
    .catch((error) => {
      handleError(error, UPDATE_ORDER_ERROR_TOAST_ID);
    });

export const syncStatusToCampaign = (number) => async (dispatch) =>
  patch(`/orders/${number}/sync_oos_status_to_campaign`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      handleError(error, UPDATE_ORDER_ERROR_TOAST_ID);
    });

export const cancelOrder = (number) =>
  patch(`/orders/${number}/cancel_complete_ro`, {
    program_id: SM_PROGRAM_ID,
  }).catch((error) => {
    const errors = error?.response?.data?.errors;
    if (errors?.length) {
      errors.forEach((err) =>
        showErrorToast({
          message: err.detail,
          config: { toastId: CANCEL_ORDER_ERROR_TOAST_ID },
        }),
      );
    }
    throw error;
  });

export const updateOrderAddress = ({ number, shipAddressId }) =>
  patch(
    `/orders/${number}/update_complete_ro`,
    withSkipContacts({
      program_id: SM_PROGRAM_ID,
      ship_address_id: shipAddressId,
    }),
  ).catch((error) => {
    const errors = error?.response?.data?.errors;
    if (errors?.length) {
      errors.forEach((err) =>
        showErrorToast({
          message: err.detail,
          config: { toastId: UPDATE_ORDER_ERROR_TOAST_ID },
        }),
      );
    }
    throw error;
  });

export const orderWithAvailabilityCheck = (orderId) => async (dispatch) =>
  get(`/orders/${orderId}/fetch_availability`)
    .then((res) => {
      const responseData = jsonDataFormatter(res);
      return formatOrder(responseData);
    })
    .catch((error) => {
      throw error;
    });

export const fetchTransactionDetails = (number) =>
  get(`/orders/${number}/last_transaction_details`).then((res) => {
    const responseData = jsonDataFormatter(res);
    const orderData = formatOrder(responseData);
    return orderData;
  });

export const rlpUserInfo = (organiserOrderId) => async () =>
  get(`/orders/${organiserOrderId}/rlp_user_info`)
    .then((res) => camelizer(res))
    .catch((error) => {
      handleError(error, RLP_USER_INFO_ERROR_TOAST_ID);
    });
